import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as t } from "react/jsx-runtime";
import n from "styled-components";
import { ColorTokens as r } from "@vds-tokens/color";
var o = n.tbody.withConfig({
    displayName: "StyledTableBody",
    componentId: "VDS__sc-b7a2pd-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), function (_ref) {
    var t = _ref.$bottomLine;
    return !t && "\n    tr {\n      border: none !important;\n    }\n  ";
  }, function (_ref2) {
    var t = _ref2.$striped,
      n = _ref2.$stripePattern;
    return t && "\n    tr:nth-child(".concat(n, ") {\n      background-color: ").concat(r.background.secondary.light.value, " !important;\n    }\n  ");
  }),
  e = function e(n) {
    return t(o, {
      $bottomLine: n.bottomLine,
      $striped: n.striped,
      $stripePattern: n.stripePattern,
      children: n.children
    });
  };
e.defaultProps = {
  bottomLine: !0,
  striped: !1,
  stripePattern: "odd"
};
export { e as default };